import { Link } from "react-router-dom";

import { ReactComponent as Icon } from "components/icons/right_arrow.svg";

import "./SeeAllButton.scss";

export const SeeAllButton = (props: {
  link: string;
}): JSX.Element => {
  return (
    <Link to={props.link} className="seeAllButton">
    See All <Icon />
    </Link>
  );
};
